// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal, Button } from 'antd';

// @ts-ignore
import { ErrorIcon } from 'images';


class NotifModal extends React.Component {
  
  handleCancel = () => {
    this.props.hideScannerModal();
  }

  render() {
		const { isDisplay, hideModal } = this.props;

		return (
    <Row onClick={hideModal}>
      <Modal
        visible={isDisplay}
        maskClosable   
        footer={[
          <Button key="back" type="primary" onClick={this.handleCancel}>
            Close
          </Button>,
        ]}
      >
        <Row justify="center">
          <Col>
            <img
              src={ErrorIcon}
              alt="logo"
              style={{ height: 65, width: 50, paddingBottom: '1em' }}
            />
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <h2>No Scanning Device Connected! Please contact your systems administrator.</h2>
          </Col>
        </Row>
      </Modal>
    </Row>
    );
  }
}

NotifModal.propTypes = {
  isDisplay: PropTypes.bool.isRequired,
  hideScannerModal: PropTypes.func
};

export default NotifModal;
